"use client";
import { GlobalContext } from "@/context";
import Image from "next/image";
import { useContext } from "react";

const CommandeContainer = () => {
  const { panierData, setPanierData, panierStatus, setPanierStatus } =
    useContext(GlobalContext);

  const plus = (product) => {
    const panierArray = panierData.map((el) =>
      el._id == product._id ? { ...el, qt: el.qt + 1 } : el
    );
    localStorage.setItem("panier", JSON.stringify(panierArray));
    setPanierData(panierArray);
  };

  const moins = (product) => {
    const panierArray = panierData.map((el) =>
      el._id == product._id ? { ...el, qt: el.qt - 1 } : el
    );
    const panierArrayFiltred = panierArray.filter((el) => el.qt > 0);
    localStorage.setItem("panier", JSON.stringify(panierArrayFiltred));
    setPanierData(panierArrayFiltred);
  };

  const deleteproduct = (product) => {
    const panierArray = panierData.map((el) =>
      el._id == product._id ? { ...el, qt: 0 } : el
    );
    const panierArrayFiltred = panierArray.filter((el) => el.qt > 0);
    localStorage.setItem("panier", JSON.stringify(panierArrayFiltred));
    setPanierData(panierArrayFiltred);
  };

  const totalWithoutDelivery = panierData?.reduce(
    (accumulator, currentValue) => {
      const finalPrice = currentValue.promo
        ? currentValue.price - (currentValue.price / 100) * currentValue.promo
        : currentValue.price;

      return accumulator + finalPrice * currentValue.qt;
    },
    0
  );
  const total = totalWithoutDelivery + (totalWithoutDelivery >= 100 ? 0 : 9);

  return (
    <>
      {/* 1 */}
      {panierData?.map((el, index) => {
        return (
          <div className="flex flex-col gap-20" key={index}>
            <div className="w-[80%] mx-auto flex flex-col lg:flex-row gap-4 ">
              <img
                src={el?.image}
                height={303}
                width={303}
                alt="Product-Photo"
                className="lg:w-[30%] w-[100%] h-[122px] lg:h-[303px] object-contain"
              />
              <div className="w-[100%] lg:w-[50%] flex flex-col gap-3">
                <h1 className="text-[24px] lg:text-[40px] font-medium ">
                  {el?.name}
                </h1>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between items-end">
                    <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                      Prix unitaire
                    </h2>

                    <div className="flex flex-col items-end">
                      <Image
                        src={"/icons/supprimer.png"}
                        width={20}
                        height={40}
                        alt="remove icon"
                        className="cursor-pointer"
                        onClick={() => deleteproduct(el)}
                      ></Image>
                      <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                        {el?.price}
                        <span>dt</span>
                      </h2>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                      Quantité
                    </h2>
                    <div className="flex gap-2">
                      <button
                        className="w-full h-full px-2 border-[#707070] border-[1px]"
                        onClick={() => moins(el)}
                      >
                        -
                      </button>
                      <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                        {el?.qt}
                      </h2>
                      <button
                        className="w-full h-full px-2 border-[#707070] border-[1px]"
                        onClick={() => plus(el)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="flex justify-between">
                    <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                      Total
                    </h2>
                    <h2 className="text-[16px] lg:text-[25px] font-normal text-[#707070]">
                      {el?.price * el.qt}
                      <span>dt</span>
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}

      <div className="flex flex-col">
        <div className="w-[60%] mx-auto flex flex-col lg:flex-row justify-end">
          <h1 className="text-[25px] font-bold">Frais de livraison: 9dt</h1>
        </div>
        <div className="w-[60%] mx-auto flex flex-col lg:flex-row justify-end">
          <h1 className="text-[25px] font-normal underline">
            A partir de 100 dinars livraison gratuite
          </h1>
        </div>
      </div>

      <div className="w-[60%] mx-auto flex flex-col lg:flex-row justify-end">
        <h1 className="text-[25px] font-bold">
          Total:{total}
          dt
        </h1>
      </div>
      
      <button
        className="text-[#FFFFFF] uppercase bg-[#CC0001] text-base px-4 w-fit self-end mx-auto md:mr-28 rounded-[19px] py-3"
        onClick={() => {
          setPanierStatus(2);
        }}
      >
        valider mon panier
      </button>
    </>
  );
};

export default CommandeContainer;
